// user
export const LOADING_USER = "LOADING_USER";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const LOGOUT_USER = "LOGOUT_USER";
// ui
export const SET_ERRORS = "SET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const LOADING_UI = "LOADING_UI";
export const UPLOADING = "UPLOADING";
export const SET_UPLOAD_PROGRESS = "SET_UPLOAD_PROGRESS";
export const OPEN_SNACKBAR = "OPEN_SNACKBAR";
export const SET_NO_AUTH_REDIRECT_FROM_URL = "SET_NO_AUTH_REDIRECT_FROM_URL";
// data
export const FETCH_DB = "FETCH_DB";
export const SET_ORGANIZATIONS = "SET_ORGANIZATIONS";
export const SET_APPS = "SET_APPS";
export const SET_APPBUNDLES = "SET_APPBUNDLES";
export const SET_DEVICES = "SET_DEVICES";
export const SET_USERS = "SET_USERS";
export const SET_INSTALLED_APPS = "SET_INSTALLED_APPS";
export const SET_DEVICE_GROUPS = "SET_DEVICE_GROUPS";
export const SET_GLOBAL_APPS = "SET_GLOBAL_APPS";
export const SET_GLOBAL_APPBUNDLES = "SET_GLOBAL_APPBUNDLES";
export const UPDATE_INSTALLED_APP_DATA = "UPDATE_INSTALLED_APP_DATA";
export const SET_DEVICE_SYSTEM_VERSIONS = "SET_DEVICE_SYSTEM_VERSIONS";
export const SET_API_KEYS = "SET_API_KEYS";
